import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { IconArrowUpRight } from '@tabler/icons-react';

const Aboutservices = () => {
  return (
    <>
      <section className='about-info'>
        <Container>
          <Row className='align-items-center justify-content-between'>
            <Col lg={4}>
            <div class="head-title mb-4 text-start"><div class="sup">what we provide ?</div><h2> <span class="text-gradient">Discover Us</span></h2>
            <p>Welcome to MyFX.ca, your trusted partner in seamless international payments and financial services. We specialize in providing fast, reliable, and cost-effective solutions for  businesses and individuals managing cross-border transactions.</p>
            </div>
            </Col>
            <Col lg={8}>
              <Row className='justify-content-between'>
                <Col md={6} className='mb-4'>
                  <Link to="/effortlessglobalpayments" className="box">
                    <img src="../Images/effortless-global-payments.png" alt="" />
                    <h3>Currency Exchange</h3>
                    <p>Offering competitive exchange rates for global currencies.</p>
                    <button as={Link} to="/effortlessglobalpayments" className='button yellow p-1 rounded-pill'><IconArrowUpRight size={20} stroke={2} /></button>
                  </Link>
                </Col>
                <Col md={6} className='mb-4'>
                  <Link to="/applyforletterofcredit" className="box">
                    <img src="../Images/apply-for-letter-of-credit.png" alt="" />
                    <h3>Letter of Credit Issuance</h3>
                    <p>Simplifying international trade with secure and efficient letters of credit.</p>
                    <button as={Link} to="/applyforletterofcredit" className='button yellow p-1 rounded-pill'><IconArrowUpRight size={20} stroke={2} /></button>
                  </Link>
                </Col>
                <Col md={6} className='mb-4'>
                  <Link to="/tuitionpaymentsforcanada" className="box">
                    <img src="../Images/tuition-payments-for-canada.png" alt="" />
                    <h3>Cross-Border Transfers</h3>
                    <p>Ensuring quick and secure money transfers worldwide, whether you're paying suppliers, supporting family, or managing business expenses</p>
                    <button as={Link} to="/tuitionpaymentsforcanada" className='button yellow p-1 rounded-pill'><IconArrowUpRight size={20} stroke={2} /></button>
                  </Link>
                </Col>
                <Col md={6} className='mb-4'>
                  <Link to="/realestateinvestmentpayments" className="box">
                    <img src="../Images/real-estate-payments.png" alt="" />
                    <h3>Real Estate and Tuition Payments</h3>
                    <p>Helping you settle international real estate investments and tuition fees with ease.</p>
                    <button as={Link} to="/realestateinvestmentpayments" className='button yellow p-1 rounded-pill'><IconArrowUpRight size={20} stroke={2} /></button>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Aboutservices